import { PushTest } from '@components/permisions/test';
import { Button } from '@components/ui/button';
import { usePanel } from '@hooks/usePanel';
import { useLogout } from '@hooks/useLogout';
import { cn } from '@utils/cn';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { UseAccountActionsParams } from './types';

export const useAccountActions = ({ onAction, fullWidth }: UseAccountActionsParams = {}) => {
  const { t } = useTranslation('app');
  const { panel, parseUrl } = usePanel();
  const logout = useLogout();
  const buttonClass = cn(fullWidth && 'w-full justify-start');

  return [
    <Button
      key="logout"
      disabled={false}
      className={buttonClass}
      variant="ghost"
      onClick={() => {
        onAction?.();
        logout(panel ? 'admin' : 'user', 'signOut');
      }}
      size="sm">
      {t('navigation.logout')}
    </Button>,
    <Link
      key="changePassword"
      to={`/${parseRoute(parseUrl(appRoutes.passwordReset))}`}
      onClick={onAction}>
      <Button
        disabled={false}
        className={cn('whitespace-nowrap', buttonClass)}
        variant="ghost"
        size="sm">
        {t('navigation.changePassword')}
      </Button>
    </Link>,
    <div key="pushTest">{import.meta.env.VITE_PUSH_TEST ? <PushTest /> : null}</div>,
    <div key="sentryTest">
      {import.meta.env.VITE_SENTRY_TEST ? (
        <button
          type="button"
          onClick={() => {
            throw new Error('Sentry Test Error');
          }}>
          Break the world
        </button>
      ) : null}
    </div>,
  ];
};
